export default "__VITE_ASSET__0Df4WIhW__"